export default __webpack_public_path__ + "static/media/bg-stay-active-subheader.63c77902.jpg";